import { dispatcher } from "../../../../helpers/projectHelper";
import { UnityEvent, waitForEventOnce } from "../../../../helpers/unityPubSub";
import { selectAutomation, setAutomation, updateAutomationTitle } from "../../../../redux/slicers/admin/curatorAutomationSlicer";
import { getAppState } from "../../../../redux/store";

export class UndoRedoAutomation {
  constructor({ undoRedoInstance, unityAutomation }) {
    this.unityAutomation = unityAutomation;
    this.undoRedo = undoRedoInstance;

    this.init();
  }

  init = () => {

    this.addAutomation = this.undoRedo.createAction(({ title, objectName }) => {
      return {
        __ACTION__: 'UNITY_AUTOMATION__ADD',
        title,
        objectName,
        undo: async () => {
          await this.unityAutomation.forceDeleteAutomation(title)
        },
        redo: () => {
          this.undoRedo.unityContext.automationModule.AddAutomationReceiver({
            automationName: title,
            objectName,
          });
        },
      };
    }, { pause: true });

    this.deleteAutomation = this.undoRedo.createAction(({ automation }) => {
      return {
        __ACTION__: 'UNITY_AUTOMATION__DELETE',
        automation,
        undo: () => {
          this.undoRedo.unityContext.automationModule.AddAutomationObjectReceiver(automation)
          this.undoRedo.unityContext.automationModule.GetAutomationListReceiver();
        },
        redo: async () => {
          await this.unityAutomation.forceDeleteAutomation(automation)
        },
      };
    }, { pause: true });

    this.changeOrder = this.undoRedo.createAction(async () => {
      // this method should be called before unity method and before changing redux state
      const prevAutomationList = selectAutomation(getAppState());
      const nextAutomationList = await waitForEventOnce(UnityEvent.OnReceiveAutomationData);

      return {
        __ACTION__: 'UNITY_AUTOMATION__CHANGE_ORDER',
        prevAutomationList,
        undo: () => {
          this.undoRedo.unityContext.automationModule.UpdateRoomAutomationReceiver(prevAutomationList);
          dispatcher(setAutomation(prevAutomationList))
        },
        redo: () => {
          this.undoRedo.unityContext.automationModule.UpdateRoomAutomationReceiver(nextAutomationList);
          dispatcher(setAutomation(nextAutomationList))
        },
      };
    });

    this.toggleStatus = this.undoRedo.createAction(({ title, newStatus, oldStatus }) => {
      return {
        __ACTION__: 'UNITY_AUTOMATION__TOGGLE_STATUS',
        title,
        newStatus,
        oldStatus,
        undo: () => {
          this.undoRedo.unityContext.automationModule.UpdateAutomationStatusReceiver(title, oldStatus);
        },
        redo: () => {
          this.undoRedo.unityContext.automationModule.UpdateAutomationStatusReceiver(title, newStatus);
        },
      };
    });

    this.changeTitle = this.undoRedo.createAction(({ automation, newTitle }) => {
      return {
        __ACTION__: 'UNITY_AUTOMATION__CHANGE_TITLE',
        undo: () => {
          this.undoRedo.pause();
          this.undoRedo.unityContext.automationModule.EditAutomationReceiver(newTitle, automation.title);
          dispatcher(updateAutomationTitle({ title: newTitle, newTitle: automation.title }));
          this.undoRedo.resume();
        },
        redo: () => {
          this.undoRedo.pause();
          this.undoRedo.unityContext.automationModule.EditAutomationReceiver(automation.title, newTitle);
          dispatcher(updateAutomationTitle({ title: automation.title, newTitle }));
          this.undoRedo.resume();
        },
      };
    });
  };
}
